import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CardFileList from "./components/CardFileList";
import TabbedCardFile from "./components/TabbedCardFile";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <header className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
            <h1 className="text-lg font-semibold text-gray-900">JavaOps</h1>
          </div>
        </header>
        <main>
          <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
            <Routes>
              <Route path="/" element={<CardFileList />} />
              <Route path="/card-file/:id" element={<TabbedCardFile />} />
            </Routes>
          </div>
        </main>
      </div>
    </Router>
  );
}

export default App;
